import styled from "styled-components";

export const ButtonBackIcon = styled.svg`
  width: 24px;
  height: 24px;

  @media (min-width: 744px) {
    width: 20px;
    height: 20px;
  }
`;

export const UploadNewAvatarUser = styled.svg`
  width: 30px;
  height: 30px;

  @media (min-width: 1024px) {
    width: 35px;
    height: 35px;
  }

  @media (min-width: 1440px) {
    width: 40px;
    height: 40px;
  }
`;

export const CloseButtonIcon = styled.svg`
  width: 30px;
  height: 30px;

  @media (min-width: 1024px) {
    width: 35px;
    height: 35px;
  }

  @media (min-width: 1440px) {
    width: 40px;
    height: 40px;
  }
`;